export const API_TYPE = {
  GAME: 'GAME',
  PLAY: 'PLAY',
  AUTH: 'AUTH',
  CHAT: 'CHAT',
} as const;
type ApiTypeKey = keyof typeof API_TYPE;
export type ApiTypeValues = (typeof API_TYPE)[ApiTypeKey];

export const API = {
  [API_TYPE.GAME]: 'https://poker-game-api-acborfv3ia-as.a.run.app',
  [API_TYPE.PLAY]: 'https://poker-play-api-acborfv3ia-as.a.run.app',
  [API_TYPE.AUTH]: 'https://poker-auth-api-acborfv3ia-as.a.run.app',
  [API_TYPE.CHAT]: 'https://chat-api-acborfv3ia-as.a.run.app',
};
